// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__Z_Qyd","full":"Container_full__1M6bE","xlWide":"Container_xlWide__2p6gt","wide":"Container_wide__31FQl"};